import http from "./http_common";

class PharmacyService {
  queryString(payload) {
    return Object.keys(payload)
      .map((key) => (key && payload[key] ? key + "=" + payload[key] : ""))
      .join("&");
  }

  GetPharmacyList(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/userPharmacyMap/list/filter?${queryString}`);
  }

  GetShareDetails(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/shareDetails/list/filter?${queryString}`);
  }

  GetDispensedDrugsDtl(payload) {
    const queryString = this.queryString(payload);
    return http.get(
      `/dispensedDrugsDtl/prescriptionforpharmacy?${queryString}`
    );
  }

  GetPrescriptionDetails(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/prescriptionDetails/list/filter?${queryString}`);
  }

  PharmacySave(payload) {
    return http.post(`/dispensedDrugsHdr/save`, payload);
  }

  PharmacyUpdate(payload) {
    return http.put(`/dispensedDrugsHdr/update`, payload);
  }

  UpdatePharmacyStatus(payload) {
    return http.put(`/patientAppointment/update/drugPrescriptionStatus`, payload);
  }

  getMedicineOrdersList(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/dispensedDrugsHdr/list/filter?${queryString}`);
  }

  getMedicineOrder(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/dispensedDrugsDtl/list/filter?${queryString}`);
  }

  cancelMedicineOrder(payload){
    return http.put('/dispensedDrugsHdr/cancel/medicine-orders',payload);
  }
  
}
export default new PharmacyService();
